module.exports = __webpack_public_path__ + "static/media/img-moduleB4.882519ad.png";